import { lazy } from "react";
import { Route } from "react-router-dom";
import MainLayout from "@/components/MainLayout/MainLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";

// Lazy-loaded route components
const GameApp = lazy(() => import("../../games/door-to-done/GameApp"));
const ScenarioListPage = lazy(() =>
  import("../../games/door-to-done/admin/ScenarioListPage").then((module) => ({
    default: module.ScenarioListPage,
  })),
);
const ScenarioFormPage = lazy(() =>
  import("../../games/door-to-done/admin/ScenarioFormPage").then((module) => ({
    default: module.ScenarioFormPage,
  })),
);
const LeaderboardPage = lazy(
  () => import("../../games/door-to-done/pages/LeaderboardPage"),
);

// Create stable component reference for games section
const GamesMainLayout = () => <MainLayout section="games" />;

export const GameRoutes = (
  <Route path="/games">
    {/* Game play route - no main layout wrapper (full screen game experience) */}
    <Route element={<GameApp />} path="door-to-done" />

    {/* Leaderboard page - full screen like the game */}
    <Route element={<LeaderboardPage />} path="door-to-done/leaderboard" />

    {/* Admin routes - wrapped with MainLayout for header, navigation, and footer */}
    <Route
      element={<AuthenticationGuard component={GamesMainLayout} />}
      path="admin"
    >
      <Route
        element={
          <PermissionGuard
            requiredRoles={["ROLE_LEARNING_ADMIN", "ROLE_SUPER_ADMIN"]}
          >
            <ScenarioListPage />
          </PermissionGuard>
        }
        path="scenarios"
      />
      <Route
        element={
          <PermissionGuard
            requiredRoles={["ROLE_LEARNING_ADMIN", "ROLE_SUPER_ADMIN"]}
          >
            <ScenarioFormPage />
          </PermissionGuard>
        }
        path="scenarios/new"
      />
      <Route
        element={
          <PermissionGuard
            requiredRoles={["ROLE_LEARNING_ADMIN", "ROLE_SUPER_ADMIN"]}
          >
            <ScenarioFormPage />
          </PermissionGuard>
        }
        path="scenarios/:id/edit"
      />
    </Route>
  </Route>
);
